import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import LinkUI from './Links/LinkUI'
import { UserContext } from '../App'
import firebase from 'firebase'
import ErrorPage from './ErrorPage/ErrorPage'
function ShowCase(props) {
    let { name } = useParams()
    if (name === '' || name === null || name === undefined) {
        name = props.linkid
    }
    const [obj, setObj] = useState({})
    const [arrayOfLinks, setArrayOfLinks] = useState([])
    const [doesUserHasLinks, setDoesUserHasLinks] = useState(false)
    const [doesLinkExist, setDoesLinkExist] = useState(false)
    const [userDetails, setUserDetails] = useState({})
    const [isLoading, setIsLoading] = useState(true)
    const [uid, setuid] = useState(null)
    useEffect(() => {
        let is = true
        setTimeout(
            () => {
                if (is) { setIsLoading(false) }
            }, 1000
        )
        return () => { is = false }
    }, [])
    useEffect(
        () => {
            let isSubscribed = true;
            if (isSubscribed) { setObj({}) }
            firebase.database().ref(name).get().then(s => {
                setuid(s.child('user').val())
                if (s.exists()) {
                    if (isSubscribed) {
                        setDoesLinkExist(true)
                        if (s.child('links').hasChildren()) {
                            setObj(s.child('links').val())
                            setDoesUserHasLinks(true)
                            console.log(s.child("user").val())
                        }
                    }
                }
            })
            return () => { isSubscribed = false }
        }, [])

    useEffect(
        () => {
            let isSubscribed = true;
            if (uid !== null) {
                firebase.database().ref("users").child(uid).get().then(snapshot => {
                    if (snapshot.exists()) {
                        if (isSubscribed) {
                            setUserDetails({ name: snapshot.child('name').val(), pic: snapshot.child("photo").val() });
                        }
                    }
                })
            }
            return () => { isSubscribed = false }

        }, [uid])
    useEffect(
        () => {
            let isSubscribed = true;
            if (obj !== {}) {
                let array = []
                for (let element in obj) {
                    array.push({ name: element, link: obj[element] })
                }
                if (isSubscribed) { setArrayOfLinks(array) }
            }

            return () => { isSubscribed = false }

        }, [obj]
    )

    return (
        <>
            {isLoading ?
                <div className='text-primary'>
                </div>
                :
                <div className='text-primary  '>
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        <div className="h4 ">
                            <img height="50" style={{ marginRight: "20px", borderRadius: "30px" }} src={userDetails.pic} alter="User Picture" />
                            {userDetails.name}'s showcase
                        </div>
                    </div>

                    {doesLinkExist ?
                        <div className='d-flex flex-column justify-content-center align-items-center'>
                            {doesUserHasLinks ?
                                arrayOfLinks.map(ele =>
                                    //<div key={ele.name} onClick={() => toLink(ele.link)} > {ele.name}</div>
                                    <div className='col-xl-9 col-sm-11 col-xs-12 m-2 col-md-10 ' key={`${ele.name}${ele.link}`}>
                                        <LinkUI
                                            name={ele.name}
                                            link1={ele.link}
                                            isInEditLink={false}
                                        />
                                    </div>
                                )
                                :
                                <div><h1>No content</h1></div>
                            }
                        </div>
                        :
                        <ErrorPage />
                    }
                </div>
            }


        </>

    )

}
export default ShowCase
